<template>
  <div class="wrap">
    <div class="title">仮登録のお申し込みを受け付けました</div>
    <div class="caption">
      登録したメールアドレスに、本登録のご案内をお送りしています。メールに記載のリンクから、本登録を完了してください。
    </div>
    <div class="btn-wrap">
      <button class="btn to-login-btn" @click="$router.push({ name: 'login' })">
        ログイン画面へ
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Complete',
}
</script>

<style scoped>
.wrap {
  padding: 2rem;
  margin: auto;
  width: 500px;
}
.title {
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 1rem;
}
.caption {
  margin-top: 2rem;
  margin-bottom: 3rem;
}
.btn-wrap {
  text-align: center;
}
.btn {
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.5rem;
  width: 17rem;
}
.to-login-btn {
  background-color: #333;
  color: white;
}
@media (max-width: 1024px) {
  .wrap {
    max-width: 500px;
    width: 80%;
  }
}
</style>